export default __webpack_public_path__ + "static/media/html-css-logo.d0efa0c2.svg";